import cx from 'clsx';
import { Text } from '@paylink/constants';
import { PaylinkState } from '@paylink/types';
import {
	InputCard,
	AmountSummary,
	PaymentInfo,
	PaymentFor,
	Header,
	Footer,
	TerminalState,
} from '@paylink/components/composed';

import { Button, HelperText } from '@shared/components/core';

import { IDesktopLayoutProps } from './DesktopLayout.types';
import styles from './DesktopLayout.module.scss';

const DesktopLayout = ({
	merchantName,
	logoId,
	amount,
	description,
	subscriptionDetails,
	orderId,
	expireAt,
	phone,
	phoneError,
	phoneNumberRequired,
	paylinkState,
	isPaylinkVerifying,
	handlePhoneInput,
	handleVerifyPhone,
	handleProceed,
	handleKeyDown,
}: IDesktopLayoutProps) => {
	const isActiveState =
		paylinkState === PaylinkState.CREATED ||
		paylinkState === PaylinkState.ACTIVE;

	if (isActiveState && !phoneNumberRequired) {
		return (
			<div
				className={cx(
					'relative d-flex items-center justify-center bg-tertiary',
					styles.pageWrapper,
				)}
			>
				<main
					className={cx(
						'd-flex flex-column items-center border-radius6 relative overflow-hidden p8',
						styles.mainContent,
					)}
				>
					<div
						className={cx(
							'width100 height100 d-flex flex-column overflow-hidden border-radius4',
							styles.proceedFrame,
						)}
					>
						<div
							className={cx(
								'width100 flex1 d-flex flex-column items-center justify-center pt8',
								styles.proceedCard,
							)}
						>
							<div
								className={cx(
									'd-flex flex-column flex1 justify-center gap8',
									styles.proceedColumn,
								)}
							>
								<Header
									logoId={logoId}
									merchantName={merchantName}
									className="pl0 pr0"
								/>

								<div className="d-flex flex-column gap6">
									<AmountSummary
										amount={amount}
										subscriptionDetails={subscriptionDetails}
									/>

									{description && <PaymentFor description={description} />}

									<HelperText message={phoneError} label={Text.PROCEED} />
									<Button
										disabled={isPaylinkVerifying}
										variant="primary"
										onClick={handleProceed}
										className="width100 border-radius2 p4"
									>
										{Text.PROCEED}
									</Button>
								</div>
							</div>
						</div>

						<Footer />
					</div>
				</main>
			</div>
		);
	}

	return (
		<div
			className={cx(
				'relative d-flex items-center justify-center bg-tertiary',
				styles.pageWrapper,
			)}
		>
			<main
				className={cx(
					'd-flex border-radius6 relative overflow-hidden',
					styles.mainContent,
				)}
			>
				<PaymentInfo
					merchantName={merchantName}
					logoId={logoId}
					amount={amount}
					description={description}
					subscriptionDetails={subscriptionDetails}
				/>
				<div className="flex1 d-flex flex-column py8 pr8 pl6">
					{isActiveState ? (
						<div
							className={cx(
								'flex1 d-flex flex-column overflow-hidden relative border1 border-grey2 border-radius4 bg-white',
								styles.rightPanel,
							)}
						>
							<div
								className={cx(
									'd-flex flex-column items-center flex1 width100 relative',
									styles.rightContent,
								)}
							>
								<InputCard
									title={Text.VERIFY_PHONE_TITLE}
									subtitle={Text.VERIFY_PHONE_SUBTITLE}
									phone={phone}
									phoneError={phoneError}
									isPaylinkVerifying={isPaylinkVerifying}
									handlePhoneInput={handlePhoneInput}
									handleVerifyPhone={handleVerifyPhone}
									handleKeyDown={handleKeyDown}
								/>
							</div>
						</div>
					) : (
						<TerminalState
							paylinkState={paylinkState}
							merchantName={merchantName}
							amount={amount}
							orderId={orderId}
							expireAt={expireAt}
							description={description}
						/>
					)}
				</div>
			</main>
		</div>
	);
};
export default DesktopLayout;
